export interface DimensionLabels {
  costPlaceLabel: string;
  costBearerLabel: string;
  projectLabel: string;
  counterpartLabel: string;
  functionLabel: string;
}

export const defaultDimensionLabels: DimensionLabels = {
  costPlaceLabel: 'Kostnadsställe',
  costBearerLabel: 'Kostnadsbärare',
  projectLabel: 'Projekt',
  counterpartLabel: 'Motpart',
  functionLabel: 'Funktion',
};

export function mergeDimensionLabels(labels?: Partial<DimensionLabels> | null): DimensionLabels {
  return {
    costPlaceLabel: labels?.costPlaceLabel || defaultDimensionLabels.costPlaceLabel,
    costBearerLabel: labels?.costBearerLabel || defaultDimensionLabels.costBearerLabel,
    projectLabel: labels?.projectLabel || defaultDimensionLabels.projectLabel,
    counterpartLabel: labels?.counterpartLabel || defaultDimensionLabels.counterpartLabel,
    functionLabel: labels?.functionLabel || defaultDimensionLabels.functionLabel,
  };
}
